import React, { useEffect, useRef } from 'react'

export function preloadPdf417() {
    void import('@bwip-js/browser')
}

export async function renderPdf417(canvas: HTMLCanvasElement, text: string) {
    const { pdf417 } = await import('@bwip-js/browser')

    return pdf417(canvas, {
        bcid: 'pdf417',
        text,
    })
}

type BarcodeValues = {
    amount: number
    iban: string
    recipient: string
    recipientStreet: string
    recipientStreetNumber: string
    recipientPostalCode: string
    recipientCity: string
    payerName?: string
    payerAddress?: string
    payerPostalCode?: string
    payerCity?: string
    model: string
    reference: string
    purposeCode?: string
    description: string
}

export function PaymentBarcode(values: BarcodeValues) {
    const canvasRef = useRef<HTMLCanvasElement>(null)

    useEffect(() => {
        let cancelled = false

        void import('@bwip-js/browser').then(({ pdf417 }) => {
            if (cancelled || !canvasRef.current) return

            const textValue = createBarcodeContent(values)

            pdf417(canvasRef.current, {
                text: textValue,

                // PDF417 / HUB3A
                columns: 9,
                eclevel: 2,
                rowmult: 4,

                // .
                // scale: 2,
                width: 85,
                height: 20,

                includetext: false,
                paddingwidth: 0,
                paddingheight: 0,
            })
        })

        return () => {
            cancelled = true
        }
    }, [values])
    return (
        <div>
            <canvas ref={canvasRef} width={190} height={60} style={{ maxWidth: '100%' }} />
        </div>
    )
}

export function createBarcodeContent(values: BarcodeValues): string {
    if (!Number.isFinite(values.amount) || values.amount < 0) {
        throw new Error('Neispravan iznos.')
    }

    const normalizedIban = values.iban.replace(/\s+/g, '').toUpperCase()
    const amountInCents = Math.round(values.amount * 100)

    // 15 digits, no decimal separator
    const formattedAmount = String(amountInCents).padStart(15, '0')

    const payerLocation = `${values.payerPostalCode || ''} ${values.payerCity || ''}`.trim()
    const recipientAddress = `${values.recipientStreet || ''} ${values.recipientStreetNumber || ''}`.trim()
    const recipientLocation = `${values.recipientPostalCode || ''} ${values.recipientCity || ''}`.trim()

    return [
        'HRVHUB30',
        'EUR',
        formattedAmount,
        sanitizeField(values.payerName, 30),
        sanitizeField(values.payerAddress, 27),
        sanitizeField(payerLocation, 27),
        sanitizeField(values.recipient, 25),
        sanitizeField(recipientAddress, 25),
        sanitizeField(recipientLocation, 27),
        normalizedIban,
        values.model,
        values.reference,
        values.purposeCode || 'COST',
        sanitizeField(values.description, 35),
    ].join('\n')
}

const disallowedBarcodeCharacters = /[^0-9A-Za-zČčĆćĐđŠšŽž ,.:?\-+'\/()]/g

function sanitizeField(value: string | undefined, maxLength: number) {
    if (!value) return ''

    return value.replace(disallowedBarcodeCharacters, '').slice(0, maxLength)
}
